import { lazy } from 'react'

export const FlowRunPageLazy = lazy(() => import('./FlowRuns'))
